import {
    Component,
    ElementRef,
    OnChanges,
    SimpleChanges,
    ViewChild,
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatChipsModule } from '@angular/material/chips';
import { IOption } from 'app/shared/shared.types';
import { BaseSlotComponent } from '../base-slot.component';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'multi-select-slot',
    templateUrl: './multi-select-slot.component.html',
    standalone: true,
    imports: [
        MatLabel,
        MatFormFieldModule,
        MatSelectModule,
        ReactiveFormsModule,
        MatIconModule,
        MatChipsModule,
        CommonModule,
    ],
    styles: [`
        :host ::ng-deep .mat-mdc-form-field-subscript-wrapper {
            display: none !important;
        }
        
        :host ::ng-deep .mat-mdc-form-field-infix {
            padding: 8px 0 !important;
            min-height: 40px !important;
        }
        
        :host ::ng-deep .mat-mdc-select-trigger {
            min-height: 24px !important;
        }
        
        :host ::ng-deep .mat-mdc-select-value {
            max-width: none !important;
        }
        
        :host ::ng-deep .mat-mdc-select-trigger .mat-mdc-chip {
            font-size: 11px !important;
            min-height: 20px !important;
            max-height: 20px !important;
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
            align-content: center !important;
            text-align: center !important;
            background-color: #DFF7E8 !important;
        }
    `]
})
export class MultiSelectSlotComponent
    extends BaseSlotComponent
    implements OnChanges
{
    selectedValues: string[] = [];

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.slot) {
            // Initialize selected values from form control
            const currentValue = this.formGroup.get(this.slot.field)?.value;
            if (currentValue && typeof currentValue === 'string') {
                this.selectedValues = currentValue.split(';').filter(v => v.trim() !== '');
                // Set the form control to array for mat-select
                this.formGroup.get(this.slot.field)?.setValue(this.selectedValues);
            }
        }
    }

    onSelectionChange(event: any): void {
        // Update selected values for display
        this.selectedValues = event.value || [];
    }

    removeValue(value: string): void {
        this.selectedValues = this.selectedValues.filter(v => v !== value);
        this.updateFormValue();
    }

    private updateFormValue(): void {
        // Keep form control as array for mat-select, but convert to string for API
        this.formGroup.get(this.slot.field)?.setValue(this.selectedValues);
    }

    getDisplayLabel(value: string): string {
        const option = this.slot.options.find(opt => opt.value === value);
        return option ? option.label : value;
    }
} 